"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var router_1 = require("@angular/router");
var new_password_component_1 = require("../new-password/new-password.component");
var service_service_1 = require("src/app/Services/service.service");
var NewPasswordHolderComponent = /** @class */ (function () {
    function NewPasswordHolderComponent(services, route, dialog) {
        var _this = this;
        this.services = services;
        this.route = route;
        this.dialog = dialog;
        this.code = this.route.snapshot.paramMap.get("code");
        var dialogRef = this.dialog.open(new_password_component_1.NewPasswordComponent, {
            width: "450px",
            disableClose: false,
            data: { code: this.code }
        });
        dialogRef.afterClosed().subscribe(function (v) {
            _this.services.route.navigate([""]);
        });
    }
    NewPasswordHolderComponent.prototype.ngOnInit = function () {
    };
    return NewPasswordHolderComponent;
}());
exports.NewPasswordHolderComponent = NewPasswordHolderComponent;
